import type React from 'react'
import type { SwapStatus, TransferStatus } from '../types/coreApi-types'

interface TransferStatusBadgeProps {
  transferStatus: TransferStatus | SwapStatus
}

const TransferStatusBadge: React.FC<TransferStatusBadgeProps> = ({
  transferStatus,
}) => {
  const getClassName = () => {
    switch (transferStatus) {
      // Legacy TransferStatus values
      case 'Created':
        return 'status-badge-info'
      case 'Pending':
        return 'status-badge-pending'
      case 'UnderReview':
        return 'status-badge-info'
      case 'Processing':
        return 'status-badge-processing'
      case 'Completed':
        return 'status-badge-success'
      case 'Cancelled':
        return 'status-badge-cancelled'
      // SwapStatus values
      case 'Review':
        return 'status-badge-info'
      case 'DepositPending':
        return 'status-badge-pending'
      case 'DepositReceived':
        return 'status-badge-info'
      case 'WithdrawPending':
        return 'status-badge-processing'
      case 'OnHold':
        return 'status-badge-cancelled'
      case 'Rejected':
        return 'status-badge-cancelled'
      default:
        return ''
    }
  }

  const getDisplayText = () => {
    switch (transferStatus) {
      // Legacy TransferStatus values
      case 'Created':
        return 'Created'
      case 'UnderReview':
        return 'Under Review'
      // SwapStatus values
      case 'Review':
        return 'Review'
      case 'DepositPending':
        return 'Deposit Pending'
      case 'DepositReceived':
        return 'Deposit Received'
      case 'WithdrawPending':
        return 'Withdraw Pending'
      case 'OnHold':
        return 'On Hold'
      case 'Rejected':
        return 'Rejected'
      default:
        return transferStatus
    }
  }

  return <div className={`${getClassName()}`}>{getDisplayText()}</div>
}

export default TransferStatusBadge
